var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagCameroune(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 9 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Cameroon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 9 V 6 H 0 Z",
    fill: "#ce1126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 3 V 6 H 0 Z",
    fill: "#007a5e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 6,0 H 9 V 6 H 6 Z",
    fill: "#fcd116"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.0519978,8.9713793 5.2773166,8.0811325 H 3.7627392 L 4.9880581,8.9713793 4.5200279,7.5309302 Z",
    fill: "#fcd116",
    transform: "translate(-0.02077718,-5.3264359) matrix(1.0009411,0,0,1.0009411,-0.00350457,-0.00858636)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCameroune);
export default __webpack_public_path__ + "static/media/flag-Cameroune.6f35aa114d7cab9af2aab3a36db8cd98.svg";
export { ForwardRef as ReactComponent };